<script setup lang="ts">
import { cn } from 'cn'
import { Primitive } from 'reka-ui'

import type { ButtonProps } from './types'

import { buttonVariants } from './variants'

const props = withDefaults(defineProps<ButtonProps>(), {
  size: 'md',
  color: 'neutral',
  variant: 'solid',
  as: 'button',
})

const disabled = computed(() => props.disabled || props.loading)
const isIconOnly = computed(() => Boolean(props.icon))
</script>

<template>
  <Primitive
    :as
    :as-child
    :class="cn(
      buttonVariants({
        size,
        color,
        variant,
        aspectSquare: props.aspectSquare || isIconOnly,
        selected,
      }),
      props.class,
    )"
    :disabled
  >
    <!-- TODO [DEV-8850] : update icon (include figma in docue icon lib first) -->
    <UiIcon
      v-if="loading"
      name="i-svg-spinners:ring-resize"
      size="1.4em"
    />
    <UiButtonIcon
      v-else-if="iconLeading"
      :size
      :name="iconLeading"
    />
    <slot>
      <UiButtonIcon
        v-if="icon"
        :name="icon"
        :size
        :class="iconClass"
      />
    </slot>
    <UiButtonIcon
      v-if="iconTrailing"
      :name="iconTrailing"
      :size
    />
  </Primitive>
</template>
